import { render, staticRenderFns } from "./ProcessingCenter.vue?vue&type=template&id=45ce1eda&scoped=true&"
import script from "./ProcessingCenter.vue?vue&type=script&lang=js&"
export * from "./ProcessingCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingCenter.vue?vue&type=style&index=0&id=45ce1eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce1eda",
  null
  
)

export default component.exports